<template>
  <div class="content">
    <div class="main">

        <div class="container text-center">
          <h2>{{ model.title }}</h2>
        </div>

        <div class="container text-left">
          <div>
            <span class="text"> Root Key: </span>
            <select v-model="model.rootKey">
              <option v-for="value in model.rootKeys">{{value}}</option>
            </select>
<!--
              <option value="fifth">Fifth Chord (dominant, power chord)</option>
-->
            <span class="text">Triad: </span>
            <select v-model="model.triad">
              <option value="none">none (dominate 5th, power chord)</option>
              <option value="major">Major Chord (major 3rd, harmonic)</option>
              <option value="minor">Minor Chord (diminished 3rd)</option>
              <option value="sus4">Suspended 4th (augmented 3rd, sub-dominant)</option>
            </select>

            <span class="text">Tetra: </span>
            <select v-model="model.tetra">
              <option value="none">none</option>
              <option value="minor7">7th (minor 7th, dominant 7)</option>
              <option value="major6">6th (major 6th, diminished 7)</option>
              <option value="major7">Major 7th (augmented 7, harmonic)</option>
            </select>
          </div>

          <div>

          </div>

          <chords-sheet :rootKey="model.rootKey" :triad="model.triad" :tetra="model.tetra">
          </chords-sheet>
        </div>

        <div>
          Chord note ordering is:  tonic - dominant - triad - tetra (1-5-3-7)<br />
          Notes for each degree are based on modes of the root key's major scale, .i.e all the notes are from the same root scale.<br />
          Common names and descriptions are based on the scale of each chord's tonic note.
        </div>

    </div>
  </div>
</template>

<script>
import ChordsSheet from './components/chordsSheet.vue'
import * as MusicData from '@/data/music_data'

export default {
  name: "Chords",
  components: {
    ChordsSheet
  },
  data() {
    return {
      model: {
        title: "Common Chords by Key",
        rootKeys: MusicData.notes,
        rootKey: 'C',
        triad: 'major',
        tetra: 'none'
      }
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
